/**
 * Componente para el botón de Perfil de la navegación inferior
 * No muestra contador, solo el estado activo/inactivo
 * Adaptado de la versión móvil
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UserIcon from '../../Icons/UserIcon';

const ProfileButton = ({ disableNavigation = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determinar si la ruta actual es la de mi cuenta
  const isActive = location.pathname === '/mi-cuenta' || location.pathname.startsWith('/mi-cuenta/');
  
  /**
   * Maneja la navegación a la pantalla de mi cuenta
   */
  const handlePress = () => {
    if (!disableNavigation) {
      navigate('/mi-cuenta');
    }
  };
  
  /**
   * Estilo del botón según estado activo
   */
  const buttonStyle = `
    relative flex flex-col items-center justify-center
    w-20 h-12 rounded-full transition-all duration-200
    ${isActive ? 'bg-neutral-700' : 'hover:bg-neutral-800'}
  `;
  
  return (
    <button
      className={buttonStyle}
      onClick={handlePress}
      aria-label="Ir a mi cuenta"
    >
      {/* Icono de usuario */}
      <UserIcon
        active={isActive}
        size={26}
        color="#A89CA6"
      />
    </button>
  );
};

export default ProfileButton;
